<!-- SELLER INFOS -->
<div class="surface-default p-6 rounded-2xl border border-gray-6 shadow-sm">
  <h3 class="text-lg font-bold text-gray-12 mb-6">Vendu par</h3>

  <div class="flex flex-col gap-6">
    <!-- Seller Identity -->
    <div class="flex items-center gap-4">
      <div
        class="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full border border-jade-a6 bg-jade-a3 text-jade-11 font-bold select-none"
      >
        @if (owner()?.identity?.avatar?.url; as avatarUrl) {
        <img [src]="avatarUrl" alt="Avatar" class="h-full w-full object-cover" />
        } @else {
        <span class="text-2xl font-bold">
          {{ owner()?.identity?.firstName?.charAt(0) || 'P' }}{{ (isOwner() ?
          owner()?.identity?.lastName?.charAt(0) : '') || '' }}
        </span>
        }
      </div>

      <div>
        <div class="text-xl font-bold leading-tight text-gray-12">
          {{ owner()?.identity?.firstName }} @if (isOwner() && owner()?.identity?.lastName; as lastName) { {{
          lastName }} }
        </div>
        <div class="text-xs text-gray-10 mt-0.5 font-medium">Propriétaire vendeur</div>
      </div>
    </div>

    <!-- Stats -->
    <div class="flex flex-col gap-3 border-t border-gray-4 pt-6">
      <div class="flex items-center gap-3 text-gray-11">
        <mat-icon class="!w-5 !h-5 !text-lg">calendar_today</mat-icon>
        <span>Membre depuis {{ owner()?.createdAt | luxonDate: 'MMMM yyyy' }}</span>
      </div>
      <div class="flex items-center gap-3 text-gray-11">
        <mat-icon class="!w-5 !h-5 !text-lg">history</mat-icon>
        @if (owner()?.metadata?.lastLoginAt; as lastLoginAt) {
        <span>Dernière activité {{ lastLoginAt | luxonDate: 'humanize' }}</span>
        } @else {
        <span>Dernière activité jamais</span>
        }
      </div>
    </div>
  </div>
</div>
